import { FabricChannel } from '@atlaskit/analytics-listeners';
export var ANALYTICS_CHANNEL = FabricChannel.aiMate;

// Which context a follow up was triggered from